import { render, staticRenderFns } from "./ChiefDeptRatingDirectionsIndexRootView.vue?vue&type=template&id=fa5c2bb8"
import script from "./ChiefDeptRatingDirectionsIndexRootView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRatingDirectionsIndexRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports